import Container from './container'

export default function Proposito() {
  return (
    <section className="text-center text-white bg-cover-proposito">
      <Container className="space-y-12 py-10 lg:py-20 xl:py-40">
        <h2 className="font-bold text-4xl lg:text-5xl group relative inline-block">
          Propósito
          <span className="absolute left-0 bottom-[-6px] h-[2px] bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] w-full transition-all duration-200" />
        </h2>
        <p className="font-light text-2xl md:text-4xl xl:text-6xl text-center max-w-[1048px] mx-auto">
          Conectar <strong className="font-bold">inovação</strong> e{' '}
          <strong className="font-bold">tecnologia</strong> para construir{' '}
          <strong className="font-bold">soluções</strong>, transformar negócios
          e{' '}
          <strong className="font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021]">
            inspirar pessoas
          </strong>
          .
        </p>
      </Container>
    </section>
  )
}
